import {Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrderRes} from "../../../@services/gen";
import OrderTypeEnum = OrderRes.OrderTypeEnum;

@Component({
  selector: 'app-choose-order-type-dialog',
  templateUrl: './choose-order-type-dialog.component.html',
  styleUrls: ['./choose-order-type-dialog.component.scss']
})
export class ChooseOrderTypeDialogComponent {
  selectedType: OrderTypeEnum;

  constructor(public dialogRef: MatDialogRef<ChooseOrderTypeDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: any) {
    this.selectedType = this.data.orderType;
  }

  selectOrderType(type: OrderTypeEnum): void {
    this.selectedType = type;
  }

  confirmSelection(): void {
    this.dialogRef.close(this.selectedType);
  }

  protected readonly OrderTypeEnum = OrderTypeEnum;
}
